import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { t } from '../i18n';

const NoResultsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchTerm = location.state?.searchTerm || '';

  const handleCreateProject = () => {
    navigate('/create-project'); // Navigate to the "Create Project" page
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>{t('noResults')} "<strong>{searchTerm}</strong>".</h1>
      <p style={styles.message}>
        {t('noRescueForObject') || "Il n'existe aucun sauvetage basé sur cet objet, soyez le premier à en créer un !"}
      </p>
      <button onClick={handleCreateProject} style={styles.button}>
        {t('createRescue') || 'Créer un sauvetage'}
      </button>
    </div>
  );
};

const styles = {
  page: { textAlign: 'center', padding: '20px' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' },
  message: { fontSize: '18px', marginBottom: '20px' },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: 'var(--green-eucalyptus)',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default NoResultsPage;